function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M19 19c-.3.3-1.2.3-1.5 0L14 15c-1.4 1-3.8 1.9-5.5 1.9-1.1 0-2.2-.2-3.3-.7s-1.9-1-2.7-1.8c-.8-.8-1.4-1.7-1.8-2.7S0 9.6 0 8.5s.2-2.2.7-3.3 1-1.9 1.8-2.7c.8-.8 1.7-1.4 2.7-1.8S7.3 0 8.5 0s2.2.2 3.3.7 1.9 1 2.7 1.8c.8.8 1.4 1.7 1.8 2.7s.7 2.1.7 3.3c0 1.8-.9 4.1-1.9 5.5l4 3.5c.2.3.2 1.2-.1 1.5zM15.1 8.6c0-1.8-.6-3.3-1.9-4.6s-2.8-1.9-4.6-1.9C6.8 2.1 5.3 2.7 4 4S2.1 6.8 2.1 8.6c0 1.8.6 3.3 1.9 4.6s2.8 1.9 4.6 1.9c1.8 0 3.3-.6 4.6-1.9s1.9-2.8 1.9-4.6z"
});

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19.2 19.2",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.2033dbca.svg";
export { ForwardRef as ReactComponent };